import {HttpService} from "./api/HttpService";
import {QueryBuilder} from "odata-query-builder/dist";

class VendorConcentrationMapService {
    getVendors(filterList) {
        if (filterList == undefined) {
            return new Promise((resolve, reject) => {
                HttpService.create().get(`/vendorconcentrationmap`)
                    .then(result => resolve(result.data))
                    .catch(err => reject(err));
            });
        }

        let newQueryBuilder = new QueryBuilder();
        newQueryBuilder.filter(f => {
            if (filterList?.residualRiskFilterOptions != undefined) {
                const residualRiskResult = filterList.residualRiskFilterOptions.filter(selectedResidualRisk => selectedResidualRisk.isSelected);
                if (residualRiskResult.length > 0) {
                    f.or(f1 => {
                        for (let i = 0; i < residualRiskResult.length; i++) {
                            f1.filterExpression('ResidualRiskName', 'eq', residualRiskResult[i].name);
                        }
                        return f1;
                    });
                }
            }

            if (filterList?.inherentRiskFilterOptions != undefined) {
                const inherentRiskResult = filterList.inherentRiskFilterOptions.filter(selectedInherentRisk => selectedInherentRisk.isSelected);
                if (inherentRiskResult.length > 0) {
                    f.or(f1 => {
                        for (let i = 0; i < inherentRiskResult.length; i++) {
                            f1.filterExpression('InherentRiskName', 'eq', inherentRiskResult[i].name);
                        }
                        return f1;
                    });
                }
            }

            if (filterList?.functionFilterOptions != undefined) {
                const functionFilterResult = filterList.functionFilterOptions.filter(selectedFunction => selectedFunction.isSelected);
                if (functionFilterResult.length > 0) {
                    f.or(f1 => {
                        for (let i = 0; i < functionFilterResult.length; i++) {
                            f1.filterPhrase(`Functions/any(e: e/FunctionId eq ${functionFilterResult[i].id})`);
                        }
                        return f1;
                    });
                }
            }
            if (filterList?.eventFilterOptions != undefined) {
                const eventFilterResult = filterList.eventFilterOptions.filter(selectedEvent => selectedEvent.isSelected);
                if (eventFilterResult.length > 0) {
                    f.or(f1 => {
                        for (let i = 0; i < eventFilterResult.length; i++) {
                            f1.filterPhrase(`Events/any(e: e/EventId eq ${eventFilterResult[i].id})` );
                        }
                        return f1;
                    });
                }
            }
            return f;
        });

        const validFilterQuery = newQueryBuilder.toQuery() == '?$filter='
                                 ? ""
                                 : newQueryBuilder.toQuery();

        return new Promise((resolve, reject) => {
            HttpService.create().get(`/vendorconcentrationmap${validFilterQuery}`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    get getFilterList() {
        return new Promise((resolve, reject) => {
            HttpService.create().get('/vendorconcentrationmap/filterOptions')
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }
}

const svc = new VendorConcentrationMapService();
export default svc;
